import React, { useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { doctorRegistration, registerUser } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import AuthTabs from "./comps/AuthTabs";
import { primaryColor } from "../../constants/colors";

export default function LoginAsDoctor() {
  pageTitle("Doctor Login");

  const [loading, setLoading] = useState(false);
  const userId = useSelector((state) => state.appSlice.userData?.id);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLoginClick = async () => {
    if (email === "") {
      toast.error("Email is required");
      return;
    }
    if (password === "") {
      toast.error("Password is required");
      return;
    }

    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      if (!userCredential.user.emailVerified) {
        toast.error("Please verify you email.");
        return;
      }
      const response = await axiosInstance.post(doctorRegistration, {
        identity: userCredential.user.email,
        device_type: 1,
        device_token: "123456",
        name: userCredential.user.email.split("@")[0],
        is_login: 1,
      });

      const loggedInUserData = response.data?.data;

      if (response.data.status) {
        if (loggedInUserData.status == 2) {
          toast.error("You are banned. Please contact admin.");
          return;
        }
        localStorage.setItem(
          "userData",
          JSON.stringify({
            userId: response.data?.data?.id,
            role: "DOCTOR",
          })
        );

        toast.success("Login successful");
        dispatch(updateDoctorData(loggedInUserData));
        if (!loggedInUserData.mobile_number || !loggedInUserData.gender) {
          navigate("/complete-doctor-profile");
        } else {
          navigate("/");
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      const errorCode = error.code;
      let errorMessage;

      switch (errorCode) {
        case "auth/invalid-email":
          errorMessage = "Invalid email format. Please check your email.";
          break;
        case "auth/user-disabled":
          errorMessage = "Your account has been disabled. Please contact support.";
          break;
        case "auth/user-not-found":
          errorMessage = "No user found with this email. Please sign up first.";
          break;
        case "auth/wrong-password":
          errorMessage = "Incorrect password. Please try again.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many failed attempts. Please try again later.";
          break;
        case "auth/invalid-credential":
          errorMessage = "Invalid username or password.";
          break;
        default:
          errorMessage = "An unexpected error occurred. Please try again.";
      }
      toast.error(errorMessage);
      console.error("Firebase login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Section topMd={60} topLg={100} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="mx-auto col-md-4 g-2">
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            <PageHeader title={"Login as Doctor"} />
            <p className="fs-md text-grey2 p-2">Manage your appointments with precision, transforming the way you connect with your patients.</p>
            <InputField label={"Email"} value={email} onChange={handleEmailChange} placeholder={"Enter Email"} />
            <PasswordInputField label={"Password"} value={password} onChange={handlePasswordChange} placeholder={"Enter Password"} trailing={<BsEye />} />
            <SecondaryButton title={"Login"} className={"mt-3"} onClick={handleLoginClick} loading={loading} />
            <div className="d-flex align-items center justify-content-center fs-normal text-grey2 mt-4 gap-2">
              New User?
              <Link to={"/doctor-register"} className="bg-transparent text-sprimary fw-medium">
                Register here
              </Link>
            </div>
            <button className="d-block bg-transparent text-sprimary fw-medium mt-3 mx-auto fs-md">Forgot password?</button>
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
